'use strict';

const Allocation = require('./index');

/**
 * Node と Content の間の相互参照を実現する Entity
 */
module.exports = Allocation.extend({
});


// WEBPACK FOOTER //
// ./balus/domain/entity/allocation/node-content.js